import React, { ReactNode } from 'react';
import { ButtonStyled } from './styles';

type IProps = {
  children: ReactNode,
  onClick: React.MouseEventHandler<HTMLButtonElement> | undefined,
  theme?: string,
  disabled?: boolean,
  rightSpace?: boolean
  buttonWidth?: string
  buttonHeight?: string
}

const Button: React.FC<IProps> = ({
  theme,
  onClick,
  children,
  disabled = false,
  rightSpace = false,
  buttonWidth,
  buttonHeight,
}) => (
  <ButtonStyled
    theme={theme}
    onClick={onClick}
    disabled={disabled}
    rightSpace={rightSpace}
    buttonWidth={buttonWidth}
    buttonHeight={buttonHeight}
  >
    {children}
  </ButtonStyled>
);

export default Button;
